import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import { useApi, useMe } from "@/lib/api";
import PlanCard from "@/components/PlanCard";
import InstallGuide from "@/components/InstallGuide";
import StatsStrip from "@/components/StatsStrip";
import HistoryTable from "@/components/HistoryTable";
import CrawlSheet from "@/components/CrawlSheet";
import UpgradeDialog from "@/components/UpgradeDialog";

export default function Dashboard() {
  const api = useApi();
  const qc = useQueryClient();
  const [crawls, setCrawls] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);
  const [scope, setScope] = useState("mine");
  const { data: me } = useMe();

  const load = useCallback(async () => {
    try {
      const [c, s] = await Promise.all([api.get(`/crawls?scope=${scope}`), api.get("/stats")]);
      setCrawls(c.data);
      setStats(s.data);
      qc.invalidateQueries({ queryKey: ["me"] });
    } catch (e) {
      toast.error("Couldn't load history");
    } finally {
      setLoading(false);
    }
  }, [api, qc, scope]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 space-y-12 sm:space-y-16" data-testid="dashboard-page">
      <PlanCard />
      <InstallGuide />
      <StatsStrip stats={stats} />
      <div className="flex justify-end -mb-10">
        <button data-testid="refresh-history-btn" onClick={load} className="h-9 px-3 rounded-md border border-slate-200 bg-white text-sm text-slate-700 hover:bg-slate-100 transition-colors flex items-center gap-2">
          <RefreshCw size={14} /> Refresh
        </button>
      </div>
      <HistoryTable crawls={crawls} loading={loading} onOpen={setActive} onChanged={load} scope={scope} setScope={setScope} hasTeam={!!me?.firm} myId={me?.user_id} />
      <CrawlSheet crawl={active} onClose={() => setActive(null)} />
      <UpgradeDialog />
    </main>
  );
}
